import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService } from '../../services/alert/alert.service';
import { IIndicator } from '../../services/alert/indicator';
import { IndicatorType } from '../../services/alert/indicator-type';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'app-indicator',
  imports: [SpinnerComponent],
  templateUrl: './indicator.component.html',
  styleUrl: './indicator.component.scss',
})
export class IndicatorComponent implements OnInit, OnDestroy {
  protected indicatortypes = IndicatorType;
  protected readonly indicators = signal<IIndicator[]>([]);

  private indicatorsSub?: Subscription;
  private readonly animationDuration: number = 300;

  private readonly alertService = inject(AlertService);

  ngOnInit(): void {
    this.indicatorsSub = this.alertService.indicator$.subscribe({
      next: (indicator: IIndicator) => {
        if (indicator) {
          this.addIndicator(indicator);
        } else {
          this.stopIndicators();
        }
      },
    });
  }

  ngOnDestroy(): void {
    this.indicatorsSub?.unsubscribe();
  }

  public stopIndicators(): void {
    this.indicators.update((indicators) => indicators.map((indicator) => ({ ...indicator, removing: true })));

    setTimeout(() => {
      this.indicators.update((indicators) => indicators.filter((indicator) => !indicator.removing));
    }, this.animationDuration);
  }

  public addIndicator(indicator: IIndicator): void {
    this.indicators.update((indicators) => {
      const existingIndex = indicators.findIndex((existing) => existing.type === indicator.type);

      if (existingIndex >= 0) {
        return indicators.map((existing, index) =>
          index === existingIndex ? { ...existing, title: indicator.title, removing: false } : existing,
        );
      }

      return [...indicators, { ...indicator }];
    });
  }
}
